<template>
	<div>
		<span style="font-size: 20px;">客户端基本属性</span>
		<div id="mycontent">
			<div class="myrow">
				<div>
					<span>客户端名称：</span><span>&nbsp;{{server.clientName}}</span>
				</div>
				<div>
					<span>客户端编码：</span><span>&nbsp;{{server.clientCode}}</span>
				</div>
			</div>
			<div class="myrow">
				<div>
					<span>IP地址：</span><span>&nbsp;{{server.serverIp}}</span>
				</div>
				<div>
					<span>类型：</span>
					<span>
						<template v-if="server.clientSort==1">&nbsp;数据采集器</template>
						<template v-if="server.clientSort==2">&nbsp;监控采集器</template>
					</span>
				</div>
			</div>
			<div class="myrow">
				<div>
					<span> 状态：</span><span><template v-if="server.clientState==1">在线</template><template v-else>离线</template></span>
				</div>
				<div>
					<span>最后在线时间：</span><span>&nbsp;{{server.updateDate}}</span>
				</div>
			</div>
			<div class="myrow">
				<div style="width: 100%">
					<span> 用途：</span><span>&nbsp;{{server.clientDesc}}</span>
				</div>
			</div>
		</div>
		<span style="font-size: 20px;">心跳日志记录</span>
		<span class="data" style="float: right;">
			<div>
				<el-date-picker v-model="dateValue" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
				 value-format="yyyy-MM-dd" @change="getDataByPrincipal()" size="mini" :picker-options="pickerOptions2">
				</el-date-picker>
				<el-button size="mini" icon="el-icon-search" @click="doDataList"></el-button>
			</div>
		</span>
		<div class="container">
			<cl-data-grid :quickSearch="false" :fields="fields" :index="true" :pagination="true" :selection="false"
			 :paramsUrl="{clientCode:clientCode,start:this.start,end:this.end}" getListUrl="/bigdata-exchange/monitor/exClientHeartLog/page"
			 @refresh="exrefresh">

				<template slot="empty">
					暂无数据！
				</template>
			</cl-data-grid>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			const that = this;
			return {
				pageload: false,
				search: '',
				dateValue: [new Date().format("yyyy-MM-dd"), new Date().format("yyyy-MM-dd")],
				start: new Date().format("yyyy-MM-dd"),
				end: new Date().format("yyyy-MM-dd"),
				nowRereflesh:function(){},

				clientId: '',
				clientCode: '',
				detCode: '',
				detName: '',
				tableData: [],
				pagesize: 10,
				page: 0,
				totalElements: '',
				//表头背景色
				tableHeaderColor({
					row,
					column,
					rowIndex,
					columnIndex
				}) {
					if (rowIndex === 0) {
						return 'background-color: #E9EEF3;color: #515a6e;font-weight: 1000;'
					}
				},
				// 工具栏
				tools: [{
					name: 'refresh', //刷新按钮el-icon-back
				}, {
					name: 'back', //返回
				}],
				// 列表数据
				fields: [{
					column: {
						align: 'center',
						label: '客户端编码',
						prop: 'clientCode'
					}
				}, {
					column: {
						label: "客户端名称",
						align: "center",
						prop: "clientName",
						width: "120",
						formatter: function(h) {
							if (h.clientCode === that.detCode) {
								return that.detName;
							}
						}
					}
				}, {
					column: {
						align: 'center',
						label: 'IP地址',
						prop: 'serverIp',
					},
				}, {
					column: {
						label: "状态",
						align: "center",
						prop: "clientState",
						width: "70",
						formatter: function(h) {
							// return h.clientState == 0 ? "离线" : "在线";
							if (h.clientState == 0) {
								return '离线';
							} else if (h.clientState == 1) {
								return '在线';
							}
						}
					},
				}, {
					column: {
						align: 'center',
						label: '最后更新时间',
						prop: 'createDate'
					},
				}],
				pickerOptions2: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				datas: [],
				server: [],
			}
		},
		mounted(){
			this.nowRereflesh();
		},
		methods: {
			exrefresh(e){
			    this.nowRereflesh=e.refresh;
			},
			back: function() {
				this.$router.push({
					name: 'bigdata-exchange-monitor-exClientList',
					query: {}
				});
			},
			details: function() { //客户端详情
				this.request.get('/bigdata-exchange/monitor/exClient/' + this.clientId + '').then((res) => {
					this.detCode = res.data.clientCode;
					this.detName = res.data.clientName;
					this.server = res.data;
				})
			},
			getDataByPrincipal: function() {
				if (this.dateValue != null) {
					this.start = this.dateValue[0];
					this.end = this.dateValue[1];
				}else{
					this.start = new Date().format("yyyy-MM-dd");
					this.end = new Date().format("yyyy-MM-dd");
				}
			},
			doDataList(){
				if(this.dateValue == null){
					this.dateValue = [new Date().format("yyyy-MM-dd"), new Date().format("yyyy-MM-dd")];
				}
				this.nowRereflesh();
			}
		},
		created: function() {
			this.request.oprahfun(this);
			this.clientId = this.$route.query.id
			this.clientCode = this.$route.query.clientCode
			this.details();
		}
	}
</script>
<style>
	#mycontent .myrow>div {
		width: 50%;
		height: auto;
	}

	#mycontent .myrow>div {
		float: left;
	}

	#mycontent .myrow>div>span:first-child {
		font-size: 14px;
		font-weight: bold;
	}

	#mycontent .myrow>div>span:last-child {
		font-size: 12px;
	}

	#mycontent .myrow {
		height: 25%;
	}

	#mycontent {
		margin-top: 20px;
		margin-bottom: 20px;
		padding: 10px;
		border: 2px solid #d2dcf8;
		border-radius: 15px;
		height: 100px;
	}

	.online {
		color: #6ce26c;
	}

	.offline {
		color: #e21d16;
	}

	.container .date span {
		margin-right: 15px;
	}
	.container .date .el-button>span {
		margin-right: 0px !important;
	}

	.container {
		margin-bottom: 20px;
	}

	.container .date {
		display: inline-block;
		margin-right: 15px;
		margin-top: 5px;
	}
</style>
